export function drawCanvas(
  canvas: HTMLCanvasElement,
  imageSrc: any,
  isWaterMark: boolean = false,
  signature?: string | null,
  artistName?: string,
  base_width: number = 175,
  base_height: number = 175,
  signature_width: number = 20,
  signature_height: number = 20,
  maxSignatureSize = 12,
  signatureOnly = false,
): void {
  if (!window) return;
  const context = canvas.getContext("2d");
  if (!context) return;


  const baseImage = new Image();
  const signatureImage = new Image();

  baseImage.src = imageSrc;
  // baseImage.src = "assets/images/8k.jpg";

  if (isWaterMark && signature) {
    signatureImage.src = signature;
  }

  baseImage.onload = () => {
    const realWidth = baseImage.naturalWidth;
    const realHeight = baseImage.naturalHeight;

    canvas.width = base_width;
    canvas.height = base_height;

    // console.log(`✅ Loaded base image: ${realWidth}x${realHeight}`);
    // console.log(`🎨 Canvas set to: ${canvas.width}x${canvas.height}`);

    context.clearRect(0, 0, canvas.width, canvas.height);

    const imgAspect = realWidth / realHeight;
    const canvasAspect = canvas.width / canvas.height;

    let drawWidth: number, drawHeight: number, offsetX: number, offsetY: number;

    if (imgAspect > canvasAspect) {
      drawWidth = canvas.width;
      drawHeight = canvas.width / imgAspect;
      offsetX = 0;
      offsetY = (canvas.height - drawHeight) / 2;
    } else {
      drawHeight = canvas.height;
      drawWidth = canvas.height * imgAspect;
      offsetX = (canvas.width - drawWidth) / 2;
      offsetY = 0;
    }

    if (!signatureOnly) {
      // console.log(`🖼 Drawing image at (${offsetX}, ${offsetY}) with size ${drawWidth}x${drawHeight}`);
      context.drawImage(baseImage, offsetX, offsetY, drawWidth, drawHeight);
    }

    if (isWaterMark) {

      signatureImage.onload = () => {
        const paddingX = drawWidth * 0.06;
        const paddingY = drawHeight * 0.08;

        // Desired max width and height (but aspect ratio will be preserved)
        const maxWidth = drawWidth * 0.1; // 10% of image width
        const maxHeight = drawHeight * 0.05; // 5% of image height

        const imgWidth = signatureImage.naturalWidth;
        const imgHeight = signatureImage.naturalHeight;

        const aspectRatio = imgWidth / imgHeight;

        let targetWidth = maxWidth;
        let targetHeight = targetWidth / aspectRatio;

        if (targetHeight > maxHeight) {
          targetHeight = maxHeight;
          targetWidth = targetHeight * aspectRatio;
        }

        const signatureX = offsetX + drawWidth - targetWidth - paddingX;
        const signatureY = offsetY + drawHeight - targetHeight - paddingY;
        context.drawImage(
          signatureImage,
          signatureX,
          signatureY,
          targetWidth,
          targetHeight
        );
      };

      signatureImage.onerror = () => {
        if (artistName) {
          const baseFontSize = Math.floor(drawHeight * 0.05);
          let fontSize = Math.min(baseFontSize, maxSignatureSize);

          context.font = `${fontSize}px Georgia`;

          const textMetrics: TextMetrics = context.measureText(artistName);
          let textWidth = textMetrics.width;

          const maxWidth = drawWidth * 0.5; // max 80% of image width

          while (textWidth > maxWidth && fontSize) {
            fontSize -= 1;

            context.font = `${fontSize}px Georgia`;
            textWidth = context.measureText(artistName).width;
          }
          const estimatedTextHeight = fontSize;


          const paddingX = drawWidth * 0.06; // 3% of drawWidth as padding from edge
          const paddingY = drawHeight * 0.03; // 3% of drawHeight as padding from edge


          const textX = offsetX + drawWidth - textWidth - paddingX;
          const textY = offsetY + drawHeight - estimatedTextHeight - paddingY;



          // Now you can calculate `textX` using text width and some padding


          context.fillStyle = "white";
          context.fillText(artistName, textX, textY);

          // console.log(`✏️ Signature image failed to load. Drawing artist name "${artistName}" at (${textX}, ${textY}) with font size ${fontSize}`);
        }
      };

      if (signature) {
        signatureImage.src = signature;
      } else if (artistName) {

        const baseFontSize = Math.floor(drawHeight * 0.05);
        let fontSize = Math.min(baseFontSize, maxSignatureSize);
        // console.log(fontSize, canvas);

        context.font = `${fontSize}px Georgia`;
        const textMetrics: TextMetrics = context.measureText(artistName);
        let textWidth = textMetrics.width;

        const maxWidth = drawWidth * 0.1; // max 80% of image width

        while (textWidth > maxWidth && fontSize) {
          fontSize -= 1;

          context.font = `${fontSize}px Georgia`;
          textWidth = context.measureText(artistName).width;
        }
        const estimatedTextHeight = fontSize;


        const paddingX = drawWidth * 0.06; // 3% of drawWidth as padding from edge
        const paddingY = drawHeight * 0.03; // 3% of drawWidth as padding from edge


        const textX = offsetX + drawWidth - textWidth - paddingX;
        const textY = offsetY + drawHeight - estimatedTextHeight - paddingY;



        // Now you can calculate `textX` using text width and some padding


        context.fillStyle = "white";
        context.fillText(artistName, textX, textY);

        // console.log(`🖊 No signature image provided. Drawing artist name "${artistName}" at (${textX}, ${textY}) with font size ${fontSize}`);
      }
    }
  };

  baseImage.onerror = () => {
    // console.error("❌ Base image failed to load. url:" + baseImage.src);
  };
}
